import { Dayjs } from 'dayjs';
import { SHORT_TIME_FORMAT } from '../../../consts/timeFormats';

export const parseDayjsTimeIntoHoursMinutesFormat: (time: Dayjs) => string = (time: Dayjs) =>
    time.format(SHORT_TIME_FORMAT);
